import createModel, { prop } from 'models/lib/create_model';

export default createModel({
  modelName: 'CustomerMerge',

  properties: {
    sourceCustomerId: prop(String).isRequired,
    destCustomerId: prop(String).isRequired,
    sourceConversationId: String,
    destConversationId: String,
    shouldClearMatches: prop(Boolean),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
